import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setProfileModalOpen,
  setProfilePage,
  get_profile_list,
  setAction,
  setId,
  setStatus,
  setSearchQuery,
  update_profile,
  setProfileId,
  setSelectedData
} from "../../../store/profile/profileSlice";

const mapStateToProps = (state) => ({
  is_profile_modal_open: state.profile.is_profile_modal_open,
  profile_list: state.profile.profile_list,
  selected_data: state.profile.selected_data,
  common_loading: state.profile.common_loading,
  total_profile_count: state.profile.total_profile_count,
  page: state.profile.page,
  c_action: state.profile.c_action,
  user_id: state.profile.user_id,
  profile_id: state.profile.profile_id,
  selected_status: state.profile.selected_status,
  search_query: state.profile.search_query
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setProfileModalOpen,
      setProfilePage,
      get_profile_list,
      setAction,
      setId,
      setStatus,
      setSearchQuery,
      update_profile,
      setProfileId,
      setSelectedData
    },
    dispatch
  );

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
